
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { pageViewUnit } from "@/config";
import { enterpriseDynamicVisit } from "@/api/policy";


@Component({
  name: "Publicy",
})
export default class Publicy extends Vue {
  @Action("policy/getPublicyData") private getPolicyData: any;
  @Action("policy/addPublicyPageView") private addPolicyView: any;
  pageViewUnit = pageViewUnit;
  pageData: any = {};
  publicyId: any = this.$route.query.publicyId;
  file: any = [];
  created() {
    this.getData();
  }
  mounted(){
    enterpriseDynamicVisit({
      id: this.$route.query.id
    }).then(res => {

    })
  }
  getData() {
    this.pageData = {
      ...this.$route.query
    }
  }

}
